module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"upperPanel":{"logout":"Logout"}},"sk":{"upperPanel":{"logout":"Odhlásiť"}},"cz":{"upperPanel":{"logout":"Odhlásit"}},"de":{"upperPanel":{"logout":"Ausloggen"}}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./static/localization/controlPanel.json
// module id = 140
// module chunks = 1